module.exports = __webpack_public_path__ + "img/sMayaQuest_193x205.dee76248.png";